import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { IKeyValue } from '@pages/distributor/interfaces/distributor.interface';
import { TableColumn } from '@shared/interface/table.interface';
import { IModalDetailWithImage, ModalConfig, ModalOption } from '@shared/components/modal/modal.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { SwiperOptions } from 'swiper';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlUtilsService } from '@utils/url-utils.service';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { UtilitiesService } from '@services/utilities.service';
import { IListDistributorExclusive } from '../../Products.interface';
import { API } from '@config/constants/api.constant';
import { ModalDetailWithImageComponent } from '@shared/components/modal/modal-detail-with-image/modal-detail-with-image.component';
import { FilterService } from '@services/filter.service';

@Component({
  selector: 'app-distributor-exclusive',
  templateUrl: './distributor-exclusive.component.html',
  styleUrls: ['./distributor-exclusive.component.scss'],
})
export class DistributorExclusiveComponent implements OnInit, OnDestroy {
  @ViewChild('swiperVariant', { static: false }) swiperVariant: SwiperComponent;
  @Input() product_name: string | undefined = '';

  tableColumns: TableColumn[];
  modalDetailConfig: ModalConfig;
  modalDetailOption: ModalOption;
  displayedColumns: string[];
  string_filter: string = '';
  distributorExclusiveList: IListDistributorExclusive[];
  baseDatasourceDistributorExclusive: BaseDatasource<IListDistributorExclusive>;
  detailDistributorExclusiveData: BehaviorSubject<IModalDetailWithImage> = new BehaviorSubject<IModalDetailWithImage>({} as IModalDetailWithImage);
  BrandId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  urlPreview: BehaviorSubject<string> = new BehaviorSubject<string>('');
  imageList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 50,
    navigation: false,
    pagination: { clickable: true },
  };
  iconClock: string = STRING_CONSTANTS.ICON.IC_CLOCK;
  iconNone: string = STRING_CONSTANTS.ILLUSTRATIONS.IL_BOX_NONE;
  iconInfo: string = STRING_CONSTANTS.ICON.IC_INFO;
  iconAction: string = STRING_CONSTANTS.ICON.IC_ACTIONS_TABLE;
  @ViewChild('modalDetail') private modalDetail: ModalDetailWithImageComponent;
  private unsubscribe: Subscription[] = [];

  constructor(
    private activeRoute: ActivatedRoute,
    private urlParamService: UrlUtilsService,
    private baseTableService: BaseTableService<any>,
    private ref: ChangeDetectorRef,
    private router: Router,
    public utilities: UtilitiesService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasourceDistributorExclusive = response));
    this.getBrand();
    this.setTableData();
    this.queryHandler();
    this.initPageInfo();
  }

  getBrand() {
    this.BrandId.next(this.activeRoute.snapshot.params.id);

    this.modalDetailConfig = {
      showFooter: false,
      showHeader: false,
    };

    this.modalDetailOption = {
      size: 'lg',
    };
  }

  initPageInfo() {
    const dataSubs = this.baseDatasourceDistributorExclusive.tableSubject.subscribe((resp) => (this.distributorExclusiveList = resp));
    this.unsubscribe.push(dataSubs);
    this.ref.detectChanges();
  }

  setTableData() {
    this.isLoading.next(false);
    this.tableColumns = [
      { title: 'DISTRIBUTOR', key: 'distributor_name' },
      { title: 'CAKUPAN AREA', key: 'area_name' },
      { title: 'CAKUPAN SUB AREA', key: 'list_sub_areas' },
      { title: 'VARIAN', key: 'list_variants' },
      { title: 'DIBUAT OLEH', key: 'submitted_by' },
      { title: 'TANGGAL DIBUAT', key: 'submitted_time' },
      { title: 'ACTION', key: 'actions' },
    ];

    this.displayedColumns = this.tableColumns.map((head) => head.key);

    if (this.distributorExclusiveList) {
      this.baseDatasourceDistributorExclusive.tableSubject.next(this.distributorExclusiveList);
    }
  }

  setDetailProduct(data: IListDistributorExclusive) {
    const title: string = 'DETAIL DISTRIBUTOR EKSKLUSIF';
    const detail: IKeyValue[] = [
      { key: 'Distributor', value: data.distributor_name },
      { key: 'Varian', value: data.list_variants?.length > 0 ? data.list_variants.join(', ').toString() : '-' },
      { key: 'Cakupan Area', value: data.area_name },
      { key: 'Cakupan Sub Area', value: this.mapSubAreaObject(data.list_sub_areas) },
      { key: 'Dibuat Oleh', value: data.submitted_by },
      {
        key: 'Tanggal Dibuat',
        value: data.submitted_time ? this.utilities.timeStampToDate(data.submitted_time, 'dd-MM-yyyy HH:mm:ss') : '-',
      },
    ];
    const images = data.product_document ? data.product_document : [];
    this.detailDistributorExclusiveData.next({ title, detail, images });
  }

  queryHandler() {
    const paramSubs = this.activeRoute.queryParams.subscribe((data) => {
      this.string_filter = data.string_filter;
      const _queryParams = this.urlParamService.sliceQueryParams();
      this.loadDataTable(_queryParams ? _queryParams : '');
    });

    this.unsubscribe.push(paramSubs);
  }

  loadDataTable(params: string) {
    return this.baseTableService.loadDataTable(API.GET_LIST_DISTRIBUTOR_EXCLUSIVE + this.BrandId.value, params);
  }

  handleAction(data: IListDistributorExclusive) {
    const mainData = data;
    if (mainData) {
      this.modalDetail.setUrlPreview = mainData.product_document ? mainData.product_document[0] : '';
      this.modalDetail.setImageList = mainData.product_document ? mainData.product_document : [];
      this.setDetailProduct(mainData);
      this.ref.detectChanges();
      return this.modalDetail.openModal();
    }
  }

  changePageEvent($event: any) {
    this.filterService.changePageEvent($event, this.string_filter ?? '');
  }

  onSearch(event: string) {
    this.filterService.onSearch(event);
    this.string_filter = '';
  }

  onClickImagePreview($event: string) {
    this.urlPreview.next($event);
  }

  slideNext() {
    this.swiperVariant.swiperRef.slideNext(100, false);
  }

  slidePrev() {
    this.swiperVariant.swiperRef.slidePrev(100, false);
  }

  counter(i: number) {
    return new Array(i);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  async handleHistory() {
    return this.router.navigate(['products/detail/distributor-exclusive/' + this.BrandId.value]).then();
  }

  setVariantItem(item: string[]) {
    if (item?.length) {
      const data = item[0];
      return {
        count: item.length - 1,
        name: data,
      };
    }
  }

  mapSubAreaObject(item: string[]) {
    const result = item?.length ? item.join(', ') : 'SEMUA';
    return this.utilities.toCapitalize(result);
  }
}
